import React from 'react';
import { useInView } from 'react-intersection-observer';
import './About.css';

const About = () => {
  const { ref, inView } = useInView({
    threshold: 0.05,
    triggerOnce: true
  });

  const services = [
    { icon: 'fas fa-calculator', label: 'Finance & Control (CPA)' },
    { icon: 'fas fa-shield-alt', label: 'Internal Audit (CIA)' },
    { icon: 'fas fa-balance-scale', label: 'Governance, Risk & Compliance' },
    { icon: 'fas fa-lock', label: 'Security & Fraud (CFE, CISA, CC)' },
    { icon: 'fas fa-chart-line', label: 'Business Excellence (IPMP)' },
    { icon: 'fas fa-sitemap', label: 'Integrated GARC Solutions' }
  ];

  return (
    <section id="about" className="about-section" ref={ref}>
      <div className="container">
        <div className="about-content">
          <div className={`about-left ${inView ? 'fade-in' : ''}`}>
            <div className="about-image-container">
              <div className="triangle-outline"></div>
              <div className="about-image">
                <img 
                  src="/Melgar_Background.png" 
                  alt="Melgar Gultiano - About"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className={`about-right ${inView ? 'fade-in' : ''}`}>
            <h2 className="section-title">A 360-DEGREE FOUNDATION</h2>
            <div className="title-underline"></div>
            
            <p className="about-text">
              I am a business polymath, a strategic executive and advisor whose two decades of deliberate, 
              cross-functional experience span the critical domains of business assurance, governance, and 
              strategic execution. Leveraging a Bachelor of Science in Accounting and a Master of Business 
              Administration (MBA), I have methodically constructed a professional foundation that transcends 
              traditional boundaries and redefines what integrated leadership means in today's complex business 
              landscape.
            </p>
            
            <p className="about-text">
              My credentials tell a compelling story of interdisciplinary mastery: CPA, CIA, CFE, CISA, CC, 
              GRCP, GRCA, and IPMP. Yet these certifications represent far more than professional achievements. 
              They reflect a deliberate journey through Finance, Governance, Risk, Compliance, Audit, Advisory, 
              and Business Excellence, equipping me with rare end-to-end visibility across the entire business 
              spectrum.
            </p>
            
            <p className="about-text">
              What distinguishes my approach is the ability to see connections where others see separation. I 
              orchestrate integrated strategic business functions with precision, harmonizing GRC, Audit, Finance, 
              Operations, and Technology into cohesive, enterprise-wide symphonies. Where organizations struggle 
              with fragmented silos, I engineer unified strategic ecosystems. My expertise flows from authentic, 
              hands-on experience across the complete business value chain and major global geographies. This 
              experience has transforms me from a conventional overseer into a catalyst for organizational 
              transformation.
            </p>
            
            <p className="about-text">
              Through The Polymath IQ, I channel this extraordinary convergence of depth, breadth, and real-world 
              insight to deliver transformative guidance for clients navigating today's interconnected business 
              challenges, driving not just compliance or efficiency, but genuine organizational alignment, 
              operational excellence, and sustainable value creation that positions enterprises for resilient, 
              long-term growth.
            </p>

            <div className="signature">
              <span className="signature-text">Melgar Gultiano</span>
            </div>

            <div className="service-buttons">
              {services.map((service, index) => (
                <button key={index} className="service-btn">
                  <i className={service.icon}></i>
                  <span>{service.label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

